import { configServices } from 'src/services';
import { Dispatch, FC, SetStateAction } from 'react';
import { FloatingLabel, Form } from 'react-bootstrap';
import { generalHelpers } from '@monorepo/helpers';
import { hideLoadingModalReducer, setAlertResponse, setValuesAndOpenAlertModalReducer, showLoadingModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useGetIsDarkMode } from 'src/custom-hooks';

type propsType = {
    closeShowNewUser: () => void;
    email: string;
    setEmail: Dispatch<SetStateAction<string>>;
};

export const UsersNewUserInvite: FC<propsType> = ({ closeShowNewUser, email, setEmail }) => {
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const inviteNewUserHandler = async () => {
        if (!generalHelpers.IsValidEmail(email)) {
            return;
        }
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: "Confirmar",
            message: `Se va a mandar un email a ${email} con una autorización para crear una cuenta`,
            execution: async () => {
                dispatch(showLoadingModalReducer());
                const response = await configServices.SendInvitationForNewUser(email);
                dispatch(hideLoadingModalReducer());
                if (!response.success) {
                    dispatch(setAlertResponse({ response }));
                    return;
                }
                dispatch(setValuesAndOpenAlertModalReducer({
                    mode: 'alert',
                    title: "Logrado",
                    message: `Se invitó a ${email}`,
                    animation: 1,
                    execution: () => closeShowNewUser()
                }));
            }
        }));
    }

    return (
        <>
        <h3 className={`text-center mt-5 ${isDarkMode ? 'text-white' : ''}`}>
            Enviarle por Email un acceso para que se cree una cuenta
        </h3>
        <FloatingLabel className={'text-dark mt-5 mb-3'}
            label={'Dirección de email'}
        >
            <Form.Control type={'email'}
                className={'form-control'}
                placeholder={''}
                value={email}
                onChange={e => setEmail((e.target as HTMLInputElement).value)}
                onKeyDown={e => e.key === 'Enter' ? inviteNewUserHandler() : null }
                autoFocus
            />
        </FloatingLabel>
        <button className={'btn btn-general-blue d-block w-100 mt-3'}
            style={{ fontWeight: 'bolder', height: '50px' }}
            onClick={inviteNewUserHandler}
            disabled={!generalHelpers.IsValidEmail(email)}
        >
            Aceptar
        </button>
        <button className={'btn btn-general-red d-block w-100 mt-3'}
            style={{ fontWeight: 'bolder', height: '50px' }}
            onClick={() => closeShowNewUser()}
        >
            Cancelar
        </button>
        </>
    );
}
